import Queue from 'common/modules/middleware/queueMiddleware'

const PopupQueue = Queue({
    reducerName: 'popupQueue',
})

export default PopupQueue
